module.exports = __webpack_public_path__ + "img/propStatus3.766a98f2.png";